import { MimeTypes } from 'constants/enums';

import fetchWithAuth from './fetchWithAuth';

const fetchFileWithMimeType = async (
  url: string,
  forceExternal?: boolean
): Promise<{ blob: Blob; fileType: MimeTypes | undefined }> => {
  try {
    const response = await fetchWithAuth(url, forceExternal);
    const blob = await response.blob();

    const fileType =
      Object.values(MimeTypes).find((type) => type === blob.type) || undefined;

    return { blob, fileType };
  } catch (error) {
    console.error('Failed to load the file', error);
    throw error;
  }
};

export default fetchFileWithMimeType;
